// Generated, DO NOT EDIT MANUALLY.
import { createTypedClient } from '../../../pplx/frontend/api-clients/core/client.js';
export const browserClient = createTypedClient();
export const createBrowserClient = (config) => createTypedClient(config);
